export const redirectPathnameAfterLogin = '/dashboard';
